import React from 'react';
import HomeCard from "./HomeCard";
import HomeStatCard from "./HomeStatCard";
import {BarChart2, Eye} from "lucide-react";

const HomeAnalyticsContent = () => {
    return (
        <HomeCard>
            <h3 className="text-2xl font-semibold mb-6">Analytics Overview</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                <HomeStatCard title="Total Views" value="50,234" icon={Eye} trend={4.7} />
                <HomeStatCard title="Avg Engagement Rate" value="8.7%" icon={BarChart2} trend={0.5} />
            </div>
            {/* Add charts here */}
        </HomeCard>
    );
};

export default HomeAnalyticsContent;
